<template>
  <div class="dummy-footer">
      <div class="item" v-for="(item, i) in histroy" :key="'list' + i">
        <div class="flex target">
          <div>
            <img class="img" src="@/assets/images/heatmap/round1.png" alt="" />
          </div>
          <div class="item flex flex-direction">
            
            <!-- <animate-number
              from="0"
              :to="item.num"
              :key="item.num"
              class="number"
            ></animate-number> -->
            <div class="flex">
              <span class="name">{{ item.name }}</span>
              <span class="uuid">{{ item.unit }}</span>
            </div>
            <div class="number">{{ item.num }}</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
// import { fontSize48 } from './comm'
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  data() {
    return {
      histroy: [
        {
          name: "累计发电量（KWh）",
          num: 0,
          unit: "",
        },
        {
          name: "累计上网电量（KWh）",
          num: 0,
          unit: "",
        },
        {
          name: "累计收益（元）",
          num: 0,
          unit: "",
        },
      ],
      swiperOptions: {
        // loop: true,
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false,
        // },
        autoplay: false,
        speed: 50,
        slidesPerView: 5,
        spaceBetween: 10,
        centeredSlides: true,
        watchSlidesProgress: true,
      },
      query: this.$route.query
    };
  },
  mounted() {
    this.zongheAll();
  },
  methods: {
    // 综合态势累计
    zongheAll() {
      let cityCode =  this.query.province || this.query.city || '000000'
      let params = {
        enCode: "zngf-qg-zjzbtj", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "累计光伏站运营天数");
          if (res) {
            this.histroy[0].num = Number(res[0].electric) || 0;
            this.histroy[1].num = Number(res[0].grid_consumption) || 0;
            this.histroy[2].num = Number(res[0].earnings) || 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
<style lang="scss" scope>
@import "~@/assets/scss/comm.scss";
.dummy-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-left: 50px;
  .swiper-slide {
    .item-c-at {
      display: none;
    }
  }

  .swiper-slide-active {
    .item {
      .item-c {
        display: none;
      }

      .item-c-at {
        display: block;
      }

      .item-l {
        font-size: $FontSize36;
      }

      .item-v {
        height: 120px;
        margin-top: -80px;

        > span {
          color: #00fdf4;
          font-size: $FontSize96;
        }
      }
    }
  }

  .target {
    width: 410px;
    height: 250px;
    // background-color:pink;
    .img {
      width: 170px;
      height: 170px;
      margin-top: 30px;
    }

    .item {
      margin-top: 40px;
      margin-left: -120px;

      .number {
        color: #00fdb1;
        font-size: $FontSize48;
        @include ffamily-HT;
        padding-left: 30px;
      }
      .name {
        padding-left: 30px;
        // padding-left: 30px;
      }
      .name,
      .uuid {
        display: block;
        color: #fff;
        height: 40px;
        line-height: 20px;
        // padding-left: 30px;
        font-size: $FontSize32;
      }
    }
  }
}
</style>